import {
  ExternalInvoicesResponseDto,
  PaginationResponseDto,
} from '@tiendanube/common';
import { DataTable } from '@tiendanube/components';
import { DataTableFooter } from 'commons/components';
import { StatusType } from 'commons/types';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { PagoNubeDataTableHeader, PagoNubeDataTableRow } from './components';
import PagoNubeInvoiceHistoryDataTableSkeleton from './PagoNubeInvoiceHistoryDataTableSkeleton';

interface PagoNubeInvoiceHistoryDataTableProps {
  data: ExternalInvoicesResponseDto[];
  pagination: PaginationResponseDto;
  onPageSelect: (page: number) => void;
  status: StatusType;
}

function PagoNubeInvoiceHistoryDataTable({
  data,
  pagination,
  onPageSelect,
  status,
}: PagoNubeInvoiceHistoryDataTableProps): JSX.Element {
  const t = useTranslationBilling();
  return (
    <>
      <DataTable>
        {status === 'loading' ? (
          <PagoNubeInvoiceHistoryDataTableSkeleton />
        ) : (
          <>
            <PagoNubeDataTableHeader />
            {data.map((row, index) => (
              <PagoNubeDataTableRow {...row} key={index} />
            ))}
          </>
        )}
      </DataTable>

      <DataTableFooter
        currentPage={pagination.currentPage}
        perPage={pagination.perPage}
        itemName={t('invoiceHistory.invoice')}
        totalItems={pagination.totalResults}
        onPageSelect={onPageSelect}
      />
    </>
  );
}

PagoNubeInvoiceHistoryDataTable.Skeleton =
  PagoNubeInvoiceHistoryDataTableSkeleton;

export default PagoNubeInvoiceHistoryDataTable;
